/**
 * Catalogue name without the category suffix or the US market tag, e.g.
 * "SE33.3K Inverter (US, 480V)" → "SE33.3K (480 V)". 240 V is the US
 * residential default, so it is dropped.
 */
export const solarShortProductName = (name: string) => {
  let voltage = '';
  const base = name
    .replace(/\(\s*US\s*(?:,\s*(\d+)\s*V)?\s*\)/gi, (_, volts?: string) => {
      if (volts && volts !== '240') voltage = ` (${volts} V)`;
      return ' ';
    })
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\s*(?:hybrid inverter|string inverter|inverter)$/i, '')
    .trim();
  return `${base || name.trim()}${voltage}`;
};
